import React from 'react';
import FormField from '../../../../../components/common/FormField';
import BasicLabel from '../../../../../components/common/BasicLabel';
import useFormValues from '../../../../cs/review/common/hook/queries/useFormValues';
import AdminFormWrap from '../AdminFormWrap/AdminFormWrap';

import { setDateFormat } from '../../../../../lib/moment';
import { ADMIN_LEVEL_TYPE_TEXT, ADMIN_STATUS_TYPE_TEXT, AdminStatus } from '../../common/constants';

const AccountAdminDetailForm = (): JSX.Element => {
  const { email, name, status, level, createDate, updateDate } = useFormValues();

  return (
    <AdminFormWrap>
      <FormField label={<BasicLabel label={'이메일'} isRequired={false} />}>
        <div className="none-editable-box">{email}</div>
      </FormField>
      <FormField label={<BasicLabel label={'이름'} isRequired={false} />}>
        <div className="none-editable-box">{name}</div>
      </FormField>
      <FormField label={<BasicLabel label={'권한레벨'} isRequired={false} />}>
        <div className="none-editable-box">{ADMIN_LEVEL_TYPE_TEXT[level]}</div>
      </FormField>
      <FormField label={<BasicLabel label={'관리자 상태'} isRequired={false} />}>
        <div className="none-editable-box">{ADMIN_STATUS_TYPE_TEXT[status as AdminStatus]}</div>
      </FormField>
      <FormField label={<BasicLabel label={'계정 생성 일자'} isRequired={false} />}>
        <div className="none-editable-box">{setDateFormat(createDate, 'LLL')}</div>
      </FormField>
      <FormField label={<BasicLabel label={'계정 수정 일자'} isRequired={false} />}>
        <div className="none-editable-box">{setDateFormat(updateDate, 'LLL')}</div>
      </FormField>
    </AdminFormWrap>
  );
};

export default AccountAdminDetailForm;
